export const CONSULTA_STALE_MS = 45 * 60 * 1000;

export const HEALTH_DOT_OK = '#16a34a';
export const HEALTH_DOT_WARNING = '#f59e0b';
export const HEALTH_DOT_ERROR = '#ef4444';
export const HEALTH_DOT_PENDING = '#94a3b8';

export type HealthDotTone = 'ok' | 'warning' | 'error';

export interface BuzonHealthStatusInput {
  ok?: boolean;
  status?: string | null;
  ultimaConsulta?: string | null;
  sync?: { ultimaConsulta?: string | null } | null;
}

export function isConsultaStale(ultimaConsulta?: string | null, now = Date.now()): boolean {
  if (!ultimaConsulta) return true;
  const t = new Date(ultimaConsulta).getTime();
  if (Number.isNaN(t)) return true;
  return now - t > CONSULTA_STALE_MS;
}

export function healthStatusOf(
  health: BuzonHealthStatusInput | null,
  now = Date.now(),
): { label: string; color: string } {
  if (!health) return { label: 'Consultando', color: HEALTH_DOT_PENDING };
  const consulta = health.sync?.ultimaConsulta ?? health.ultimaConsulta;
  const stale = isConsultaStale(consulta, now);
  const statusUpper = (health.status || '').toUpperCase();
  if (health.ok) {
    if (stale || statusUpper === 'WARNING') {
      return { label: 'WARNING', color: HEALTH_DOT_WARNING };
    }
    return { label: 'OK', color: HEALTH_DOT_OK };
  }
  if (statusUpper === 'DEGRADED') return { label: 'Degradado', color: HEALTH_DOT_WARNING };
  return { label: 'Caído', color: HEALTH_DOT_ERROR };
}

export function healthStatusTone(statusLabel: string): HealthDotTone | undefined {
  if (statusLabel === 'OK') return 'ok';
  if (statusLabel === 'WARNING' || statusLabel === 'Degradado') return 'warning';
  if (statusLabel === 'Consultando') return undefined;
  return 'error';
}

export function healthDotColor(tone?: HealthDotTone): string | undefined {
  if (tone === 'ok') return HEALTH_DOT_OK;
  if (tone === 'warning') return HEALTH_DOT_WARNING;
  if (tone === 'error') return HEALTH_DOT_ERROR;
  return undefined;
}

export function consultarNotice(status: number): { type: 'ok' | 'error'; text: string } {
  if (status === 422) return { type: 'error', text: 'El buzón ya está sincronizando' };
  if (status >= 200 && status < 300) return { type: 'ok', text: 'Sincronización iniciada' };
  return { type: 'error', text: 'No se pudo iniciar la sincronización' };
}
